import { Timeline } from 'antd';
import React from 'react';
import "./index.css";

const dot = (status) => {
    return (
        <div className={colorMap[status]}></div>
    )
}

const getStatus = (status) => {
    return (
        <span className={`status-${colorMap[status]}`}>{status}</span>
    )
}

const colorMap = {
    '维修保养': 'red',
    '部署前训练': 'green',
    '执勤部署': 'blue',
}

const ShipTimeLine = (props) => (
    <div className='box'>
        <Timeline mode='left'>
            {
                props.shipEvents.map((item) => 
                    item.isChange ? <Timeline.Item className="larger" label={getStatus(item.status)} key={item.id} color={colorMap[item.status]} dot={dot(item.status)}>{item.event}</Timeline.Item> : <Timeline.Item label={getStatus(item.status)} key={item.id} color={colorMap[item.status]}>{item.event}</Timeline.Item>
                )
            }
        </Timeline>
    </div>
);

export default ShipTimeLine;